import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import UsersStore from '../../stores/UsersStore'
import LoadingWrapper from '../../components/LoadingWrapper'
import Toast from '../../components/Toast'
import { Button, Grid } from 'semantic-ui-react'
import ModalUnsavedConfirmation from '../../components/ModalUnsavedConfirmation'
import UserForm from '../../components/Users/UserForm'

@withRouter
@observer
class UsersEditScreen extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object
  }

  constructor (props) {
    super(props)
    if (!props.match.params.userId) {
      props.history.goBack()
    }
    this.usersStore = new UsersStore()
    window.document.title = 'Modifier un utilisateur'
  }

  componentDidMount () {
    this.usersStore.loadOne(this.props.match.params.userId)
  }

  componentWillUnmount () {
    this.usersStore = null
  }

  handleSaveUser = () => {
    this.usersStore.save(this.props.match.params.userId).then((result) => {
      if (result.success) {
        this.props.history.push('/users')
      }
    })
  }

  handleRevertUser = () => {
    this.usersStore.revert()
  }

  render () {
    const { isLoading, isSaving, toasts, roles, equipments } = this.usersStore
    if (isLoading) {
      return <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
    }
    return (
      <>
        <ModalUnsavedConfirmation
          when={this.usersStore.user.isDirty}
          onSave={this.handleSaveUser}
          onDiscard={this.handleRevertUser}
        />
        <LoadingWrapper loading={isSaving} message='Sauvegarde en cours...' />
        <LoadingWrapper loading={isLoading} message='Chargement en cours...' />
        <Toast toasts={toasts} />
        <Grid columns='equal'>
          <Grid.Row>
            <Grid.Column>
              <UserForm
                usersStore={this.usersStore}
                roles={roles} equipments={equipments}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Column>
            <Button
              content='Enregistrer'
              disabled={!this.usersStore.isDirty || isSaving}
              primary
              onClick={this.handleSaveUser}
            />
          </Grid.Column>
        </Grid>
      </>
    )
  }
}

export default UsersEditScreen
